/// <amd-module name="Wit/WorkItemForm/Attachments/AttachmentMoreButton" />
import * as React from "react";
import { useMemo } from "react";
import { IContextualMenuProps, IMenuItem, MoreButton } from "VSSUI/Menu";
import * as Resources from "Wit/WorkItemForm/Resources";
import { ICurriedAttachmentActions } from "./AttachmentActions";

interface IAttachmentMoreButtonProps extends ICurriedAttachmentActions {
    className?: string;
}

export function AttachmentMoreButton({
    className,
    onEditComment,
    onPreviewAttachment,
    onDownloadAttachment,
    onDeleteAttachment,
    onCopyAttachmentUrl
}: IAttachmentMoreButtonProps) {
    const menu: IContextualMenuProps = useMemo(() => {
        let menu = {
            menuProps: {
                id: "attachment-menu",
                items: [] as IMenuItem[]
            }
        };
        if (onEditComment) {
            menu.menuProps.items.push({
                id: "edit-comment",
                groupKey: "attachment-actions",
                iconProps: { iconName: "Edit" },
                text: Resources.EditComment,
                onActivate: onEditComment
            });
        }
        const permanentItems = [
            {
                id: "preview-attachment",
                groupKey: "attachment-actions",
                iconProps: { iconName: "Preview" },
                text: Resources.PreviewAttachment,
                onActivate: onPreviewAttachment
            },
            {
                id: "copy-attachment-url",
                groupKey: "attachment-actions",
                iconProps: { iconName: "Copy" },
                text: Resources.CopyAttachemntURL,
                onActivate: onCopyAttachmentUrl
            },
            {
                id: "download-attachment",
                groupKey: "attachment-actions",
                iconProps: { iconName: "Download" },
                text: Resources.DownloadAttachment,
                onActivate: onDownloadAttachment
            }
        ];
        menu.menuProps.items.push(...permanentItems);

        if (onDeleteAttachment) {
            menu.menuProps.items.push({
                id: "delete-attachment",
                groupKey: "attachment-actions",
                iconProps: { iconName: "Delete" },
                text: Resources.DeleteAttachment,
                onActivate: onDeleteAttachment
            });
        }
        return menu;
    }, [onEditComment, onPreviewAttachment, onCopyAttachmentUrl, onDownloadAttachment, onDeleteAttachment]);

    return <MoreButton className={className} hideDropdownIcon subtle contextualMenuProps={menu} />;
}
